module.exports = __webpack_public_path__ + "static/media/nii-logo.6c3600d7.png";